/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Yaml_Ref_N4Inputs */

const en_to_yaml_ref_n4 = /** @type {(inputs: To_Yaml_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An ordinary word needs no quoting and gets none.`)
};

const ko_to_yaml_ref_n4 = /** @type {(inputs: To_Yaml_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`평범한 단어는 인용이 필요 없고 인용되지 않습니다.`)
};

const ja_to_yaml_ref_n4 = /** @type {(inputs: To_Yaml_Ref_N4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ありふれた語は引用が不要で、引用されません。`)
};

/**
* | output |
* | --- |
* | "An ordinary word needs no quoting and gets none." |
*
* @param {To_Yaml_Ref_N4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_yaml_ref_n4 = /** @type {((inputs?: To_Yaml_Ref_N4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Yaml_Ref_N4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_yaml_ref_n4(inputs)
	if (locale === "ko") return ko_to_yaml_ref_n4(inputs)
	return ja_to_yaml_ref_n4(inputs)
});